//@flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
//types
import { type Match } from 'react-router-dom';
import { type Currencies, type Currency } from '../../../utilities/types';
import {
  type DirectMerchantDetail,
  type PartnerDetail
} from '../components/types';
import CrudTableShow from '../../../modules/CrudTable/CrudTableShow';
import {
  loadCommissionShow,
  changePage,
  updateLoadCommissionShow,
  expandDirectMerchantRow,
  expandPartnersRow,
  setPerPageFilter,
  orderByDirectMerchantsProcessingVolume,
  orderByDirectMerchantsTransactionFee,
  orderByDirectMerchantsCommission,
  //
  orderByPartnersNumMerchants,
  orderByPartnersProcessingVolume,
  orderByPartnersTransactionFee,
  orderByPartnersCommission,
  orderByPartnersCompanyName,
  orderByDirectMerchantsCreatedAt,
  orderByDirectMerchantsMerchantName
} from './reducer';
import TableColumn from '../../../modules/CrudTable/components/TableColumn';
import RequiresActionDesktop from './RequiresActionDesktop';
import SummaryFooter from './SummaryFooter';
import RequiresActionMobile from './RequiresActionMobile';
import {
  makeGetCurrencyName,
  makeGetCurrencyColor,
  makeGetCurrencyType,
  makeGetCryptoWallet,
  getPartnerCurrency
} from '../../../utilities/selectors';
import { dig } from '../../../utilities/misc';
import DirectMerchantTableRow from '../components/show/DirectMerchantTableRow';
import DirectMerchantTableHeader from '../components/show/DirectMerchantTableHeader';
import PartnersTableRow from '../components/show/PartnersTableRow';
import PartnersTableHeader from '../components/show/PartnersTableHeader';
import { formatCurrency } from '../../../utilities/numberFormatting';

type Props = {
  // Initialize
  loadCommissionShow: () => void,
  match: Match,
  location: Location,
  loading: boolean,
  failedLoad: boolean,
  failedUpdateLoad: boolean,
  currencies: Currencies,
  currencyColor: string,
  currencyName: string,
  currencyType: string,
  activeTable: string,
  cryptoWallet: string,
  viewportDevice: boolean,
  endMonthMinimum: number,
  partnerCurrency: Currency,
  // setActiveTable: string => void,

  //TableHeader
  // // DM
  orderByDirectMerchantsCreatedAt: () => void,
  orderByDirectMerchantsMerchantName: () => void,
  orderByDirectMerchantsProcessingVolume: () => void,
  orderByDirectMerchantsTransactionFee: () => void,
  orderByDirectMerchantsCommission: () => void,
  orderByDMCreatedAtState: number,
  orderByDMMerchantNameState: number,
  orderByDMProcessingVolumeState: number,
  orderByDMTransactionFeeState: number,
  orderByDMCommissionState: number,
  // // P
  orderByPartnersCompanyName: () => void,
  orderByPartnersNumMerchants: () => void,
  orderByPartnersProcessingVolume: () => void,
  orderByPartnersTransactionFee: () => void,
  orderByPartnersCommission: () => void,
  orderByPCompanyNameState: number,
  orderByPNumMerchantsState: number,
  orderByPProcessingVolumeState: number,
  orderByPTransactionFeeState: number,
  orderByPCommissionState: number,

  //Paginator
  paginatorTotal: number,
  currentPage: number,
  changePage: ({
    id: number | string,
    page: number
    // perPage: number
  }) => void,
  previouslyVisited: number[],

  //Paginator Filter
  perPageFilter: string,
  setPerPageFilter: () => void,
  // closeExpandedRow: null => void, TODO:?

  summary: {
    transaction_amount: number,
    transaction_fee: number,
    revenue_share: number,
    transaction_count: number
  },

  updateLoadCommissionShow: ({
    id: string | number,
    newActiveTable: string
  }) => void,
  updateTableLoading: boolean,
  expandDirectMerchantRow: () => void,
  expandPartnersRow: () => void,
  loadCommissionShow: () => void,
  directMerchantExpandedRow: number,
  partnersExpandedRow: number,
  directMerchant: DirectMerchantDetail,
  partners: PartnerDetail,
  selectedIso: string,
  selectedCurrency: Currency,
  requiresBankAccount: boolean
};

class CommissionDueShow extends Component<Props> {
  handleToggle = (directMerchantAction, partnerAction) => {
    switch (this.props.activeTable) {
      case 'Direct Merchants':
        return directMerchantAction;
      case 'Partners':
        return partnerAction;
      default:
        return;
    }
  };

  handleTableRow = () =>
    // $FlowFixMe
    this.handleToggle(<DirectMerchantTableRow />, <PartnersTableRow />);

  handleTableHeader = () =>
    this.handleToggle(
      <DirectMerchantTableHeader
        orderBy={{
          createdAt: this.props.orderByDirectMerchantsCreatedAt,
          merchantName: this.props.orderByDirectMerchantsMerchantName,
          processingVolume: this.props.orderByDirectMerchantsProcessingVolume,
          transactionFee: this.props.orderByDirectMerchantsTransactionFee,
          commission: this.props.orderByDirectMerchantsCommission
        }}
        orderState={{
          createdAt: this.props.orderByDMCreatedAtState,
          merchantName: this.props.orderByDMMerchantNameState,
          processingVolume: this.props.orderByDMProcessingVolumeState,
          transactionFee: this.props.orderByDMTransactionFeeState,
          commission: this.props.orderByDMCommissionState
        }}
      />,
      <PartnersTableHeader
        orderBy={{
          companyName: this.props.orderByPartnersCompanyName,
          numMerchants: this.props.orderByPartnersNumMerchants,
          processingVolume: this.props.orderByPartnersProcessingVolume,
          transactionFee: this.props.orderByPartnersTransactionFee,
          commission: this.props.orderByPartnersCommission
        }}
        orderState={{
          companyName: this.props.orderByPCompanyNameState,
          numMerchants: this.props.orderByPNumMerchantsState,
          processingVolume: this.props.orderByPProcessingVolumeState,
          transactionFee: this.props.orderByPTransactionFeeState,
          commission: this.props.orderByPCommissionState
        }}
      />
    );

  handleTableData = () =>
    this.handleToggle(this.props.directMerchant, this.props.partners);

  handleExpandRow = () =>
    this.handleToggle(
      this.props.expandDirectMerchantRow,
      this.props.expandPartnersRow
    );

  handleExpandedRow = () =>
    this.handleToggle(
      this.props.directMerchantExpandedRow,
      this.props.partnersExpandedRow
    );

  toggleTable = newActiveTable => {
    if (this.props.activeTable !== newActiveTable) {
      this.props.updateLoadCommissionShow({
        id: this.props.selectedIso,
        newActiveTable
      });
    }
  };

  render() {
    const processingVolumeTotal =
      dig(this.props.summary, 'transaction_amount') || '';
    const transactionFeeTotal =
      dig(this.props.summary, 'transaction_fee') || '';
    const commissonTotal = dig(this.props.summary, 'revenue_share') || '';
    const transactionCount = dig(this.props.summary, 'transaction_count') || '';
    const payoutExpectedAt =
      dig(this.props.summary, 'payout_expected_at') || '';
    const exceedsMinimumPayout = dig(
      this.props.summary,
      'exceeds_minimum_payout'
    );

    const tableData = this.handleTableData();

    return (
      <CrudTableShow
        // Initialize
        loadTableShowData={this.props.loadCommissionShow}
        location={this.props.location}
        match={this.props.match}
        loading={this.props.loading}
        currencies={this.props.currencies}
        failedLoad={this.props.failedLoad}
        failedUpdateLoad={this.props.failedUpdateLoad}
        // Paginator
        paginatorTotal={this.props.paginatorTotal}
        currentPage={this.props.currentPage}
        changePage={this.props.changePage}
        previouslyVisited={this.props.previouslyVisited}
        // Paginator Filter
        currentPerPage={this.props.perPageFilter}
        setPerPage={this.props.setPerPageFilter}
        perPageOptions={[10, 25, 50]}
        // Summary
        TableSummaryColumn={[
          <TableColumn
            first
            key={'SC1'}
            data={[
              [
                'Processing Vol. Total:',
                formatCurrency(
                  processingVolumeTotal,
                  this.props.selectedCurrency
                )
              ],
              [
                'Transaction Fee Total:',
                formatCurrency(transactionFeeTotal, this.props.selectedCurrency)
              ],
              [
                'Commission Total:',
                formatCurrency(commissonTotal, this.props.selectedCurrency)
              ]
            ]}
          />,
          <RequiresActionDesktop
            key={'SC2'}
            currencyName={this.props.currencyName}
            requiresCryptoWallet={!this.props.cryptoWallet}
            requiresBankAccount={this.props.requiresBankAccount}
            currencyType={this.props.currencyType}
          />
        ]}
        TableSummaryFooter={[
          <SummaryFooter
            key={'SF1'}
            exceedsMinimumPayout={Boolean(exceedsMinimumPayout)}
            currencyType={this.props.currencyType}
            payoutExpectedAt={payoutExpectedAt}
            endMonthMinimum={this.props.endMonthMinimum}
            partnerCurrency={this.props.partnerCurrency}
          />,
          <RequiresActionMobile
            key={'SF2'}
            currencyName={this.props.currencyName}
            requiresCryptoWallet={!this.props.cryptoWallet}
            requiresBankAccount={this.props.requiresBankAccount}
            currencyType={this.props.currencyType}
          />
        ]}
        tableSummaryOptions={{
          title1: 'Commission Details:',
          title2: `${this.props.currencyName} Payout`,
          titleColor: this.props.currencyColor,
          subTitle: `Number of Transactions: ${transactionCount}`,
          hasHorizontalRule:
            this.props.currencyType === 'fiat' ||
            (this.props.currencyType === 'crypto' &&
              !this.props.cryptoWallet &&
              this.props.viewportDevice)
        }}
        // Table Body
        updateTableLoading={this.props.updateTableLoading}
        tableData={tableData}
        tableBodyOptions={{
          text: 'No Transactions',
          model: 'Transactions',
          img: 'receipt',
          selectedIso: this.props.selectedIso
        }}
        TableRow={this.handleTableRow()}
        expandRow={this.handleExpandRow()}
        expandedRow={this.handleExpandedRow()}
        // Table Header
        TableHeader={this.handleTableHeader()}
        // Toggle
        tableToggleOptions={{
          sectionValue1: 'Direct Merchants',
          sectionValue2: 'Partners',
          activeSection: this.props.activeTable,
          handleClick: this.toggleTable
        }}
      />
    );
  }
}

// Needed for correct memoization https://github.com/reduxjs/reselect#accessing-react-props-in-selectors
const makeMapStateToProps = () => {
  const getCurrencyName = makeGetCurrencyName();
  const getCurrencyColor = makeGetCurrencyColor();
  const getCurrencyType = makeGetCurrencyType();
  const getCryptoWallet = makeGetCryptoWallet();
  const mapStateToProps = (state, ownProps) => ({
    directMerchant: dig(
      state,
      'commissionPayouts',
      'commissionDue',
      'show',
      'directMerchant',
      'commissions'
    ),
    orderByDMCreatedAtState:
      state.commissionPayouts.commissionDue.show.directMerchant
        .orderByCreatedAtState,
    orderByDMMerchantNameState:
      state.commissionPayouts.commissionDue.show.directMerchant
        .orderByMerchantNameState,
    orderByDMProcessingVolumeState:
      state.commissionPayouts.commissionDue.show.directMerchant
        .orderByProcessingVolumeState,
    orderByDMTransactionFeeState:
      state.commissionPayouts.commissionDue.show.directMerchant
        .orderByTransactionFeeState,
    orderByDMCommissionState:
      state.commissionPayouts.commissionDue.show.directMerchant
        .orderByCommissionState,
    partners: dig(
      state,
      'commissionPayouts',
      'commissionDue',
      'show',
      'partners',
      'referral_details'
    ),
    orderByPCompanyNameState:
      state.commissionPayouts.commissionDue.show.partners
        .orderByCompanyNameState,
    orderByPNumMerchantsState:
      state.commissionPayouts.commissionDue.show.partners
        .orderByNumMerchantsState,
    orderByPProcessingVolumeState:
      state.commissionPayouts.commissionDue.show.partners
        .orderByProcessingVolumeState,
    orderByPTransactionFeeState:
      state.commissionPayouts.commissionDue.show.partners
        .orderByTransactionFeeState,
    orderByPCommissionState:
      state.commissionPayouts.commissionDue.show.partners
        .orderByCommissionState,
    cryptoWallet: getCryptoWallet(state, ownProps),
    currencyName: getCurrencyName(state, ownProps),
    currencyColor: getCurrencyColor(state, ownProps),
    currencyType: getCurrencyType(state, ownProps),
    loading: state.commissionPayouts.commissionDue.show.loading,
    summary: state.commissionPayouts.commissionDue.show.summary,
    currencies: state.global.currencies,
    directMerchantExpandedRow:
      state.commissionPayouts.commissionDue.show.directMerchant.expandedRow,
    partnersExpandedRow:
      state.commissionPayouts.commissionDue.show.partners.expandedRow,
    currentPage: state.commissionPayouts.commissionDue.show.currentPage,
    previouslyVisited:
      state.commissionPayouts.commissionDue.show.previouslyVisited,
    paginatorTotal: state.commissionPayouts.commissionDue.show.paginatorTotal,
    perPageFilter: state.commissionPayouts.commissionDue.show.perPageFilter,
    updateTableLoading:
      state.commissionPayouts.commissionDue.show.updateTableLoading,
    failedLoad: state.commissionPayouts.commissionDue.show.failedLoad,
    failedUpdateLoad:
      state.commissionPayouts.commissionDue.show.failedUpdateLoad,
    activeTable: state.commissionPayouts.commissionDue.show.activeTable,
    viewportDevice: state.global.viewportDevice,
    selectedIso: state.commissionPayouts.commissionDue.show.selectedIso,
    //TODO: make selector
    selectedCurrency:
      state.global.currencies[
        state.commissionPayouts.commissionDue.show.selectedIso
      ],
    requiresBankAccount: state.account.bankAccount.formState === 'create',
    endMonthMinimum: state.commissionPayouts.index.endMonthMinimum,
    partnerCurrency: getPartnerCurrency(state)
  });
  return mapStateToProps;
};

const mapDispatchToProps = {
  loadCommissionShow,
  updateLoadCommissionShow,
  changePage,
  expandDirectMerchantRow,
  expandPartnersRow,
  setPerPageFilter,
  orderByDirectMerchantsCreatedAt,
  orderByDirectMerchantsMerchantName,
  orderByDirectMerchantsProcessingVolume,
  orderByDirectMerchantsTransactionFee,
  orderByDirectMerchantsCommission,
  //
  orderByPartnersCompanyName,
  orderByPartnersNumMerchants,
  orderByPartnersProcessingVolume,
  orderByPartnersTransactionFee,
  orderByPartnersCommission
};

export default connect(
  makeMapStateToProps,
  mapDispatchToProps
)(CommissionDueShow);
